<template>
  <div id="app">
    <router-view v-wechat-title="$route.meta.title"></router-view>
  </div>
</template>

<script>
import store from "@/store";
import router from '@/router';
import Vue from 'vue'
  export default {
    name: 'App',
    computed: {
        _isMobile () {
            const flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
            return flag;
        }
    },

    mounted () {
        // 检查登录状态
        this.getLoginStats();
        // 移动端 跳转到对应路径
        if (this._isMobile) {
            this.$router.replace('/indexFe');
        } else {
          // this.$router.replace('/index');
        }
    },

    watch: {
      //监听路由变化
      "$route": {
        handler() {
          if (this.$route) {
            this.getLoginStats()
          }
          return
        },
        immediate: true
      }
    },

    methods: {
      //检查登录状态
      getLoginStats() {
        //手机跳出
        // if(this.$isFe) return;
        //首页和登录等路由 不需要验证登录
        let routeArr = [ '/', '/index', '/indexFe', '/downApp', '/loginCode', '/loginPassword', '/refundProtocol', '/teachersTeam', ]
        if(routeArr.includes(this.$router.currentRoute.path)) return;
         const studentCode = store.state.user.Code;
        if (!studentCode) {
        // Vue.prototype.$toast.center("未登录，请先登录");
        localStorage.removeItem("user");
        router.replace({
          path: "/loginCode",
          query: {
            redirect: router.currentRoute.fullPath,
          },
        });
      }
      },

    },

  }
</script>


// WEBPACK FOOTER //
// src/App.vue